import Cookies from 'js-cookie'
const JWT_TOKEN = Cookies.get('jwt_token')

let MODE = /*process.env.REACT_APP_MODE || */ 'DEVELOPMENT'

let BASE_URL = ''
if (MODE === 'DEVELOPMENT') {
  // BASE_URL = 'http://localhost:7000'
  // BASE_URL = 'https://api.taskplanet.org'
  BASE_URL = 'https://taskplanet-backend.herokuapp.com'
} else if (MODE === 'PRODUCTION') {
  BASE_URL = 'https://api.taskplanet.org'
}

const API_URL = {
  root_api: `${BASE_URL}/`,
  health_api: `${BASE_URL}/health`,
  validate_username_api: `${BASE_URL}/validate_username`,
  validate_email_api: `${BASE_URL}/validate_email`,
  validate_mobile_api: `${BASE_URL}/validate_mobile`,
  login_api: `${BASE_URL}/login`,
  register_api: `${BASE_URL}/register`,
  forgot_password_api: `${BASE_URL}/forgot_password`,
  change_password_api: `${BASE_URL}/secure/change_password`,
  reset_password_api: `${BASE_URL}/reset_password`,
  fetch_earning_summary_api: `${BASE_URL}/secure/earnings_summary`,
  fetch_incomes_api: `${BASE_URL}/secure/incomes`,
  fetch_points_api: `${BASE_URL}/secure/points`,
  fetch_profile_info_api: `${BASE_URL}/secure/profile`,
  fetch_teams_api: `${BASE_URL}/secure/teams`,
  update_profile_api: `${BASE_URL}/secure/profile`,
  withdraw_api: `${BASE_URL}/secure/withdraw`,
  withdraw_history_api: `${BASE_URL}/secure/withdrawals`,
  create_task_api: `${BASE_URL}/secure/task`,
  view_task_api: `${BASE_URL}/secure/task`,
  delete_task_api: `${BASE_URL}/secure/task`,
  update_task_api: `${BASE_URL}/secure/task`,
  view_all_tasks_api: `${BASE_URL}/secure/tasks`,
  submit_answer_api: `${BASE_URL}/secure/answer`,
  update_answer_api: `${BASE_URL}/secure/answer`,
  task_history_api: `${BASE_URL}/secure/taskHistory`,
  fetch_profile_api: `${BASE_URL}/secure/profile`,
  view_all_answer_creator: `${BASE_URL}/secure/viewAnswersByTaskcreater`,
  verify_answer_api: `${BASE_URL}/secure/verifyanswer`,
  myanswers_api: `${BASE_URL}/secure/myanswers`,
  change_email_api: `${BASE_URL}/secure/profile`,
  fetch_user_api: `${BASE_URL}/secure/users`,
  access_chat_api: `${BASE_URL}/secure/chat`,
  fetch_chat_api: `${BASE_URL}/secure/chat`,
  fetch_all_messages_api: `${BASE_URL}/secure/message`,
  send_message_api: `${BASE_URL}/secure/message`,
  create_lead_api: `${BASE_URL}/secure/lead`,
  fetch_leads_api: `${BASE_URL}/secure/lead`,
  withdraw_histroy_api: `${BASE_URL}/secure/withdrawals`,
}

export { JWT_TOKEN, API_URL }
